<template>
  <v-container id="dashboard" fluid grid-list-lg class="mx-0 pa-0">
    <v-layout row wrap>
      <v-flex md3 sm6 xs12 v-for="(stat,index) in stats.monthlyStats" v-bind:key="index">
        <v-card :class="stat.bgColor" dark>
          <v-container fluid grid-list-sm dark>
            <v-layout class="mt-0 mb-0 mx-1" row wrap>
              <v-flex sm3 hidden-xs-only>
                <v-icon class="mx-0" x-large dark>{{stat.icon}}</v-icon>
              </v-flex>
              <v-flex sm9 xs12>
                <v-layout class="mt-0 mb-0 pa-0" row wrap>
                  <v-flex d-flex xs12>
                    <div class="silver--text subheading">{{stat.title}}</div>
                  </v-flex>
                  <v-flex d-flex xs12>
                    <div class="silver--text display-1">{{stat.data}}</div>
                    <!--v-btn outline class="darkgrey--text darken-1" right flat small>{{stat.action.label}}</v-btn-->
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout class="" row wrap>
      <v-flex md4 xs12>
        <v-card light>
          <doughnutbanks :style="dark ? 'background-color: black;': ''" :banks="banks" :key="banksCompKey"></doughnutbanks>
        </v-card>
      </v-flex>
      <v-flex md4 xs12>
        <v-card light>
          <doughnutworkers :style="dark ? 'background-color: black;': ''" :workers="workers" :key="workersCompKey"></doughnutworkers>
        </v-card>
      </v-flex>
      <!--v-flex md4 xs12>
        <v-card light>
          <bar v-bind:query="query"></bar>
        </v-card>
      </v-flex-->
      <v-flex md4 xs12>
        <v-card light >
          <line-chart :style="dark ? 'background-color: black;': ''" v-bind:query="query"></line-chart>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
/* globals Store */
import Bar from "../components/chart/Bar";
import Doughnutbanks from "../components/chart/DoughnutBanks";
import Doughnutworkers from "../components/chart/DoughnutWorkers";
import LineChart from "../components/chart/LineChart";
import { mapState } from "vuex";
export default {
  props: ['dark'],
  name: "Dashboard",
  data() {
    return {
      workersCompKey: 0,
      banksCompKey: 0,
      searchVm: {
        contains: {
          worker: '',
          bank: ''
        },
        between: {
          date: { from: null, until: null },
          amount: { former: 0, latter: 0 }
        }
      },
      query: "",
      stats: {
        monthlyStats: [
          {
            bgColor: "cyan darken-3",
            icon: "card_membership",
            title: "Оборот всего",
            data: "",
            action: {
              label: "More Info",
              link: ""
            }
          },
          {
            bgColor: "deep-orange  lighten-3",
            icon: "card_membership",
            title: "Кол-во проверок",
            data: "",
            action: {
              label: "More Info",
              link: ""
            }
          },
//          {
//            bgColor: "blue-grey darken-1",
//            icon: "card_membership",
//            title: "Оборот продажа",
//            data: "",
//            action: {
//              label: "More Info",
//              link: ""
//            }
//          },
//          {
//            bgColor: "pink  lighten-4",
//            icon: "card_membership",
//            title: "Оборот покупка",
//            data: "",
//            action: {
//              label: "More Info",
//              link: ""
//            }
//          }
        ]
      }
    };
  },
  computed: {
    ...mapState("filters", {
      from: "from",
      until: "until",
      from_time: "fromTime",
      until_time: "untilTime",
      worker: "worker",
      bank: "bank",
      banks: "banks",
    }),
    ...mapState("dashboard", {
      resume: "resume",
      workers: "workers",
      banks: "banks",
      loading: "loading",
    }),
  },
  components: {
    Bar,
    Doughnutbanks,
    Doughnutworkers,
    LineChart
  },
  methods: {
    refreshFilters() {
      this.$Progress.start();
      this.formQuery();
      Store.dispatch("dashboard/getResume", this.query);
      Store.dispatch("dashboard/getBanksDoughnut", this.query);
      Store.dispatch("dashboard/getWorkersDoughnut", this.query);
    },
    formSum (sum) {
      return sum.toString().split('').reverse().map((el, index) => index % 3 !== 2 ? el : ` ${el}`).reverse().join('');
    },
    formQuery () {
      this.query = "from=" + this.from + "%20" + this.from_time + "&until=" + this.until + "%20" + this.until_time +
        (this.worker ? "&worker=" + this.worker : '');
    }
  },
  watch: {
      loading() {
        if (!this.loading){
          this.$Progress.finish();
        }
      },
      workers() {
        this.workersCompKey += 1;
      },
      banks() {
        this.banksCompKey += 1;
      },
      from() {
        this.refreshFilters();
      },
      until() {
        this.refreshFilters();
      },
      from_time() {
        this.refreshFilters();
      },
      until_time() {
        this.refreshFilters();
      },
      worker() {
        this.refreshFilters();
      },
      bank() {
        this.refreshFilters();
      },
      resume() {
        this.stats.monthlyStats[0].data = this.formSum(Math.round(this.resume.resume[0].sum));
        this.stats.monthlyStats[1].data = this.formSum(Math.round(this.resume.resume[0].count));
      },
  },
  created() {
    this.refreshFilters()
  },
};
</script>




// WEBPACK FOOTER //
// Dashboard.vue?a3926e8c